import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

import { SUPPORTED_CUSTOM_PAGE_VIDEO_RECIPES } from '../../../../../constants/recipes';
import ErrorHandler from '../../../../../libs/errors/errors';
import { hasAnyRecipe } from '../../../../modules/foundation/hooks/use-recipe';
import { TILE_TYPE_VIDEO } from '../../../../modules/hero/components/CustomHeroForm/components/TileConfiguration/TileConfiguration.constants';
import { calculateTilesPerRow, getTileVideoData } from '../../../../modules/hero/services/tile';
import {
  isVideoUrlValid,
  normalizeVideoData,
} from '../../../../modules/video/VideoPlayerEditor/VideoPlayerEditor.utils';

export function componentConfigurationToTile(componentConfiguration) {
  const {
    id,
    fastId,
    files = [],
    contentNodes = [],
    interactions = [],
    childConfigurations,
    ...componentConfigurationRest
  } = componentConfiguration;

  return {
    componentConfiguration: {
      componentConfigurationId: id,
      componentName: fastId,
      ...componentConfigurationRest,
    },
    images: files.map(({ id: businessFileId, ...rest }) => ({ businessFileId, ...rest })),
    contentNodes: contentNodes.map(({ id: contentNodeId, ...rest }) => ({
      contentNodeId,
      ...rest,
    })),
    interactions,
  };
}

export function convertDynamicTilesToCustomHero(dynamicTiles, page) {
  const customHeroComponentConfiguration = componentConfigurationToTile(dynamicTiles);

  const tiles = _get(dynamicTiles, 'childConfigurations', []).map(componentConfigurationToTile);
  const tilesPerRow = calculateTilesPerRow(tiles);

  return {
    ...customHeroComponentConfiguration,
    page,
    tiles,
    tilesPerRow,
  };
}

export async function loadDataWrapper(dataLoaderCallbacks, setLoading) {
  setLoading(true);
  try {
    await Promise.all(dataLoaderCallbacks.map((callback) => callback()));
  } catch (error) {
    ErrorHandler.capture(error);
  } finally {
    setLoading(false);
  }
}

export function isCustomHeroVideoValid(customHero = {}) {
  const tiles = _get(customHero, 'tiles', []);

  return tiles.every((tile) => {
    if (_get(tile, 'componentConfiguration.data.tileType') !== TILE_TYPE_VIDEO) {
      return true;
    }

    const { source, url } = normalizeVideoData(getTileVideoData(tile));
    return isVideoUrlValid(source, url);
  });
}

export function customHeroHasData(customHero = {}) {
  const tiles = _get(customHero, 'tiles', []);

  return tiles.some((tile) => {
    const { images = [], contentNodes = [], interactions = [] } = tile;
    if (!_isEmpty(images)) {
      return true;
    }

    const hasContent = contentNodes.some(({ content }) => !_isEmpty(content));
    if (hasContent) {
      return true;
    }

    const hasInteractions = interactions.some(({ enabled }) => enabled);
    if (hasInteractions) {
      return true;
    }

    const hasVideo = !_isEmpty(getTileVideoData(tile));
    if (hasVideo) {
      return true;
    }

    return false;
  });
}

export function isVideoTileSupported(patch) {
  return hasAnyRecipe(patch, SUPPORTED_CUSTOM_PAGE_VIDEO_RECIPES);
}
